import { useContext } from 'react';
import { CreditLogContext } from 'contexts/credit_log_context';

const useCreditLogContext = () => {
    return useContext(CreditLogContext);
};

export default useCreditLogContext;
